import React from 'react';
import { renderToString } from 'react-dom/server';
import PropTypes from 'prop-types';
import { appContentUrl } from 'settings';
import { AddFavorite, Image, SharingPopup, WebsiteSplitter, LinkHandler } from 'C4';

const formatImage = (image, appId) => {
  let newImage = image;
  if (newImage.startsWith('/')) {
    newImage = newImage.substring(1);
  }
  if (!newImage.startsWith(`app/${appId}/`)) {
    newImage = `app/${appId}/${newImage}`;
  }
  return newImage;
};

const parseURL = (url, type, appId) => {
  switch (type) {
    case 'pdf':
      return `${appContentUrl}${appId}/salesCompanion/${typeof url === 'object' ? url[0] : url}`;
    case 'image':
      return `${appContentUrl}${appId}/salesCompanion/${typeof url === 'object' ? url[0] : url}`;
    default: return url;
  }
};

const Slideshow = (props) => {
  const {
    appId,
    fancybox,
    options,
    urls,
  } = props;

  const images = [];
  for (let i = 1; i < urls.length; i += 1) {
    const key = i;
    images.push((
      <div
        key={`ss_${key}`}
        href={urls[i].includes('http') ? urls[i] : parseURL(urls[i], 'image', appId)}
        data-options={options}
        data-fancybox={fancybox}
        data-trigger={fancybox}
        data-type={urls[i].includes('http') && 'iframe'}
        style={{ display: 'none' }}
      >
        <Image
          src={parseURL(urls[i], 'image', appId)}
          overrideZeroSize={100}
          alt="hidden"
        />
      </div>));
  }
  return (images);
};

const FavoriteLink = (props) => {
  const {
    image,
    pageID,
    sub_type: subType,
    subtitle,
    title,
    type: originType,
  } = props.info;

  const { favorites } = props;

  const {
    unid,
    type,
    app_id: appId,
  } = props.contentInfo;

  let { url } = props.info;
  if (url) {
    if (url.includes(',')) {
      url = url.split(',');
    }
  }

  let shareUrl = url;
  if (Array.isArray(shareUrl)) {
    shareUrl = window.location.href;
  } else {
    shareUrl = `${appContentUrl}${appId}/salesCompanion/${shareUrl}`;
  }

  const fancyOptions = {
    infobar: true,
    thumbs: {
      autoStart: true,
      axis: 'x',
    },
    baseClass: 'customBox',
    buttons: ['thumbs', 'share', 'close'],
    share: {
      tpl: renderToString(<SharingPopup url={shareUrl} />),
    },
  };

  const newImage = formatImage(image, appId);
  return (
    <div className="favorite__card" key={pageID}>
      <AddFavorite
        appId={appId}
        favorites={favorites}
        viewType={type}
        upID={unid}
        color
      />
      <LinkHandler
        info={props.info}
        appId={appId}
        url={url}
        type={type}
        subType={subType}
        UniqueID={pageID}
        className="favorite__button"
        dataOptions={JSON.stringify(fancyOptions)}
        dataFancybox={pageID}
        dataTrigger={pageID}
        favorites
      >
        {/* Dummy image to fool fancybox thumbnails process */}
        {typeof url === 'object' &&
          <Image
            src={`${appContentUrl}${appId}/salesCompanion/${url[0]}`}
            alt="placeholder thumbnail"
            className="hidden"
          />
        }
        <div className="favorite__image--container">
          <Image src={`https://cdn.travpromobile.com/apptool/${newImage}`} alt={unid} />
        </div>
        <h4>{title}</h4>
        <p>{subtitle}</p>
      </LinkHandler>
      {typeof url === 'object' &&
        <Slideshow
          appId={appId}
          fancybox={pageID}
          options={JSON.stringify(fancyOptions)}
          urls={url}
        />}
      {(subType === 'multi') &&
        <WebsiteSplitter
          itemID={pageID}
          appID={appId}
          type={originType !== 'toolbox' ? 'FastFacts' : originType}
        />}
    </div>
  );
};

export default FavoriteLink;

FavoriteLink.propTypes = {
  info: PropTypes.shape(PropTypes.string.isRequired),
  favorites: PropTypes.shape(),
  contentInfo: PropTypes.shape(PropTypes.string.isRequired),
};

FavoriteLink.defaultProps = {
  contentInfo: {},
  favorites: {},
  info: {},
};
